import React from 'react';

import { Col, Row } from 'react-bootstrap';
import { connect, useSelector } from 'react-redux';

import {
  refreshData,
} from '../../../../common/components/DataTable/redux/dataTableActions';

import { CreateNoteButton, NotesList } from '../../../../common/components';
import { InternalButtonBar } from '../../../layout/components';

const SchemeNotes = ({ schemeIds, resourceType }) => {

  const { isSubmitting } = useSelector((state) => state.notes);


  const notableResource = { data: { id: schemeIds } };

  return (
    <div className="product-container">
      <h2>Notes</h2>
      <div>
        <NotesList
          key={schemeIds + isSubmitting}
          resourceId={schemeIds}
        />

        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['scheme.edit'],
                  button: (
                    <CreateNoteButton
                      multipleIdsString={schemeIds.join(',')}
                      label="Add a Note"
                      className="pull-right"
                      notableResourceType={resourceType}
                      notableResource={notableResource}
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SchemeNotes;
